import React from 'react';
import styled from 'styled-components';
import { colors } from '../../theme/color';

type Props = {
  color?: string;
  className?: string;
};

export const LoadingIconCoupon: React.FC<Props> = ({ color, className, ...props }) => {
  return (
    <Container className={className} {...props}>
      <Spinner color={color} />
    </Container>
  );
};

const Spinner = styled.div<Props>`
  @keyframes loyalty-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  border: 5px solid ${({ color }) => color || colors.green.darker(10)};
  border-radius: 50%;
  animation: loyalty-spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${({ color }) => color || colors.green.darker(10)} transparent transparent
    transparent;
`;

const Container = styled.div`
  display: inline-block;
  position: relative;
  width: 25px;
  height: 25px;

  & ${Spinner}:nth-child(1) {
    animation-delay: -0.45s;
  }

  & ${Spinner}:nth-child(2) {
    animation-delay: -0.3s;
  }

  & ${Spinner}:nth-child(3) {
    animation-delay: -0.15s;
  }
`;
